module.exports = __webpack_public_path__ + "static/media/gonzalez.66cb31f9.png";